
import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';

interface DesktopNavigationProps {
  direction: 'rtl' | 'ltr';
}

const DesktopNavigation: React.FC<DesktopNavigationProps> = ({ direction }) => {
  const { t } = useTranslation();
  
  return (
    <nav className="hidden md:flex items-center space-x-8">
      <div className={`flex items-center ${direction === 'rtl' ? 'space-x-reverse' : ''} space-x-8`}>
        <a href="#features" className="text-synagogue-blue hover:text-synagogue-gold transition-colors">
          {t('navProduct')}
        </a>
        <a href="#pricing" className="text-synagogue-blue hover:text-synagogue-gold transition-colors">
          {t('navPricing')}
        </a>
        <a href="#demo" className="text-synagogue-blue hover:text-synagogue-gold transition-colors">
          {t('navDemo')}
        </a>
      </div>
    </nav>
  );
};

export default DesktopNavigation;
